import React from "react";
import PropTypes from "prop-types";
import qs from "qs";

import { ErrorMsg } from "../../components";

const Unauthorized = ({ location }) => {
  const query = qs.parse(location.search.replace("?", "")); //remove ? from start of location.search
  const email = query["email"];
  const message = query["message"];
  return (
    <div style={{ maxWidth: "400px", margin: "24px auto" }}>
      <ErrorMsg
        message={"Access denied"}
        description={`Your email ${email} does not have access to this application. ${message}`}
      />
    </div>
  );
};

Unauthorized.propTypes = {
  location: PropTypes.object.isRequired
};

export default Unauthorized;



// WEBPACK FOOTER //
// ./src/views/unauthorized/Unauthorized.jsx